import { Icon } from "@chakra-ui/react"
import { useAppSelector } from "../../app/hooks"
import MeterBar from "../../components/MeterBar"
import { useGameTriggerContext } from "../../hooks/GameTriggers"
import { selectGameMentalHealth } from "./gameSlice"
import { FaFaceSmile } from "react-icons/fa6"

export const MentalHealthMeter = () => {
  const turnMentalHealth = useAppSelector(selectGameMentalHealth)
  const { mentalHealthModifier } = useGameTriggerContext()

  return (
    <MeterBar
      label="Happiness"
      value={turnMentalHealth}
      max={100}
      icon={<Icon boxSize={6} as={FaFaceSmile} />}
      modifier={mentalHealthModifier}
      color="#5eead4"
    />
  )
}
